module.exports = __webpack_public_path__ + "img/banner.dff4e495.jpg";